import { PagedSearch } from 'src/app/shared';

export class NewsArticleSearchDto extends PagedSearch {
  Name: string;
  ArticleDateStart: Date;
  ArticleDateEnd: Date;
}
